import CollapsibleFilterPanel from './CollapsibleFilterPanel'
export default CollapsibleFilterPanel